import Ajax from "Utils/ajax";
// export const getSalaryFixation = (data) => Ajax.post('account/getSalaryFixation',data);
export const getSalaryFixationByAppraisalId = (data) => Ajax.post('account/getSalaryFixationByAppraisalId',data);